import React from "react";
import {withStyles} from '@material-ui/core/styles';
import Avatar from "@material-ui/core/Avatar/Avatar";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import i18n from "../../i18n";
import CsrfField from "../Form/CsrfField";
import {getInitials} from "./utils";

class ToolbarProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {anchorEl: null};
    }

    handleOpenMenu = (event) => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };

    handleCloseMenu = () => {
        this.setState({
            anchorEl: null
        });
    };

    handleProfile = (id) => {
        this.handleCloseMenu();
        window.location = `/users/${id}/edit`;
    };

    handleLogout = () => {
        this.handleCloseMenu();
        document.getElementById('logout-form').submit();
    };

    render() {
        const {classes, user} = this.props;

        if (!user) {
            return null;
        }

        return (
            <div className={classes.avatar}>
                <div className={classes.toolbarDivider}/>

                <Avatar className={classes.avatarImage}>
                    {getInitials(user.name)}
                </Avatar>

                <Button
                    color="primary"
                    className={classes.button}
                    onClick={this.handleOpenMenu}
                >
                    {user.name}
                    <Icon>
                        arrow_drop_down
                    </Icon>
                </Button>

                <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                >
                    <MenuItem onClick={() => this.handleProfile(user.id)}>
                        {i18n.get('user.profile')}
                    </MenuItem>
                    <MenuItem onClick={this.handleLogout}>
                        {i18n.get('user.logout')}
                    </MenuItem>
                </Menu>

                <form
                    id="logout-form"
                    action="/logout"
                    method="POST"
                    className={classes.logoutForm}
                >
                    <CsrfField/>
                </form>
            </div>
        );
    }
}

const styles = theme => ({
    avatar: {
        margin: '0 8px',
        display: 'flex',
    },
    avatarImage: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
        padding: theme.spacing.unit, // to shrink left and right padding
        fontSize: 15,
        fontWeight: 400,
        textTransform: 'none',
        whiteSpace: 'nowrap'
    },
    toolbarDivider: {
        width: 1,
        margin: theme.spacing.unit * 2,
        border: 'none',
        backgroundColor: theme.palette.divider,
    },
    logoutForm: {
        display: 'none',
    },
});

export default withStyles(styles)(ToolbarProfile);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Toolbar/Profile.jsx